export const portalData = {
  // Fax Details
  hasFax: false,
  faxNo: "",
  
  // Whatsapp details
  hasWhatsApp: true,
  whatsAppNo: "012-8293303",
  whatsAppLinkNo: "011-32377788",
  whatsAppNoHolderName: "Singamata",
  hasAltWhatsApp: true,
  altWhatsAppNo: "012-8293303",
  altWhatsAppNoHolderName: "Singamata",
  hasAltWhatsApp1: false,
  altWhatsAppNo1: "",
  altWhatsAppNoHolderName1: "",
  hasAltWhatsApp2: false,
  altWhatsAppNo2: "",
  altWhatsAppNoHolderName2: false,
  
  // Phone number details
  hasPhoneNo: true,
  phoneNo: "012-8293303",
  hasAltPhoneNo: true,
  altPhoneNo: "011-32377788",
  
  // Telephone number details
  hasTellNo: true,
  tellNo: "012-8293303",
  tellNoHolderName: "Singamata",
  hasAltTellNo: true,
  altTellNo: "011-32377788",
  altTellNoHolderName: "Singamata",
  hasAltTellNo2: false,
  altTellNo2: "",
  altTellNoHolderName2: "",
  
  // Portal information details
  portalNameXSpace: "Singamata Reef Resort",
  portalName: "Singamata Reef Resort",
  portalNameUppercase: "SINGAMATA REEF RESORT",
  portalFullName: "Singamata Adventures & Reef Resort",
  portalFullNameUppercase: "SINGAMATA ADVENTURES & REEF RESORT",
  portalShortAddress: "P.O. Box 109, Jalan Kastam",
  portalAddress: "P.O. Box 109, Seafast Complex, Jalan Kastam, Semporna, Sabah",
  portalAddressFirstPart: "P.O. Box 109, Jalan Kastam,",
  portalAddressSecondPart: "Sabah",
  portalAddressDetails: "P.O. Box 109, Seafast Complex, Jalan Kastam, Semporna, Sabah",
  hasPortalRegNo: false,
  portalRegNo: "",
  portalBoatDropLocation: "",
  
  // Portal Bank Details
  portalBankName: "Maybank",
  portalBankAddress: "Lot 1, Block 567, Jalan Panglima Jakarullah, 91308, Semporna, Sabah",
  portalBankAccHolderName: "Singamata Adventures & Reef Resort",
  portalBankAccNo: "510040006307",
  hasPortalBankSwiftCode: true,
  portalBankSwiftCode: "MBBEMYKL",
   
  portalEmail: "tctong_97@hotmail.com",
  portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,
  
  appName: "Island Resort Centralised Reservation Platform",

  // GST details
  hasGst: false,
  gstNo: true,
   
  // Website
  portalWebsite: "https://www.singamata.com",
  portalWebLinkText: "singamata.com",
  portalPromotionPage: "https://www.singamata.com/promotion/",
  portalTermAndCond: "https://www.singamata.com/terms-and-conditions",
 
  // Travoxis Website
  travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
 
  // Facebook page link
  facebookMessengerLink: "https://www.facebook.com/singamata/",
 
  // portal S3 base url
  s3AwsUrl: "",
 
  adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,

  // Portal Jetty names
  jettyOne: "Seafast Jetty",
  jettyTwo: "Singamata",
  fromLocation: "",
  jettyThree: "",
  jettyOneToTwoTime: "",
  jettyTwoToOneTime: "",
}